module.exports = __webpack_public_path__ + "static/media/backgroundNatura.4acadee2.png";